<bepatient-question-title-v3
  [title]="question.label"
  [constraints]="question.constraints"
  [color]="color"
  [isBlur]="isBlur"
  [errors]="question.errors"
  [infos]="question.infos"
  [css]="question.css"
  [key]="question.key"
  [dirty]="dirty"
  [value]="value"
  [type]="question.controlType"
  [display]="question.display"
  [formGroup]="formGroup"
  [hasCondition]="question.hasCondition"
>
</bepatient-question-title-v3>
<ng-container [formGroup]="formGroup">
  <div #signatureInput class="signature-input">
    <ion-img *ngIf="!blankSignature" [src]="value"></ion-img>
    <div
      [hidden]="!blankSignature"
      class="blank-signature-pad"
      (click)="presentModal()"
    >
      <p>{{ 'SIGNATURE.PLACEHOLDER' | translate }}</p>
    </div>
    <ion-buttons
      class="signature-buttons"
      [style.paddingBottom]="16"
      [hidden]="blankSignature"
    >
      <ion-button
        fill="clear"
        color="dark"
        [disabled]="readonly"
        (click)="modify()"
      >
        <ion-icon name="pencil"></ion-icon>
        {{ 'SIGNATURE.BUTTON.MODIFY' | translate }}
      </ion-button>
      <ion-button
        fill="clear"
        color="dark"
        [disabled]="readonly"
        (click)="delete()"
      >
        <ion-icon name="trash"></ion-icon>
        {{ 'SIGNATURE.BUTTON.DELETE' | translate }}
      </ion-button>
    </ion-buttons>
  </div>
</ng-container>
